import About from './About.vue';

function routeFor(handle, name) {
  return {
    path      : '/' + handle,
    name      : name,
    component : About,
    props     : {handle},
    meta      : {isPublic: true}
  };
}

const routes = [
  routeFor('cookies', 'Cookies'),
  routeFor('privacy', 'Privacy'),
  routeFor('terms', 'Terms'),
];

export default routes;

